import { render, staticRenderFns } from "./EmployerMarketingItem.vue?vue&type=template&id=c5cf0540&scoped=true"
import script from "./EmployerMarketingItem.vue?vue&type=script&lang=js"
export * from "./EmployerMarketingItem.vue?vue&type=script&lang=js"
import style0 from "./EmployerMarketingItem.vue?vue&type=style&index=0&id=c5cf0540&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5cf0540",
  null
  
)

export default component.exports